/*
 * IMPORTS
 */
import { gql } from "@apollo/client"; // NPM: Apollo client for handling graphql request.

/*
 * GRAPH
 */
const Index = gql`
  mutation MyMutation($BrandDetailsId: ID!) {
    BrandDetailsRemove(BrandDetailsId: $BrandDetailsId) {
      message
      status
    }
  }
`;

/*
 * EXPORTS
 */
export default Index;
